/* eslint-disable react/no-danger */
import React from 'react';
import { includes } from 'lodash';
import { Container } from './styles/Container.styled';
import { DWTCContext } from '../utils/context';

export default function HtmlContent({ data, dir, id }) {
  const { cssClass } = React.useContext(DWTCContext);

  const { title, htmlText } = data;

  // const [content, setContent] = React.useState({
  //   title: '',
  //   htmlContent: '',
  // });

  // React.useEffect(() => {
  //   setContent({
  //     title: data.title,
  //     htmlContent: data.htmlContent,
  //   });
  // }, []);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };
  return (
    <Container id={id} className="html-container" dir={dir}>
      {title && <h2>{title}</h2>}
      {htmlText && (
        <div dangerouslySetInnerHTML={{ __html: htmlText }} color={getTheme()} />
      )}
    </Container>
  );
}
